<template>
    <div style="overflow: hidden; height: 100vh">
        <div style="height: 300px;width: 500px;margin:200px auto;text-align: center">
            <h1 style="font-size: 120px;color: black">404</h1>
            <p style="color: red">这个网页出错了</p>
            <el-button round size="medium" type="warning " @click="home" style="margin-top: 100px">返回首页</el-button>
        </div>


    </div>
</template>

<script>
import {setRoutes} from "@/router";

export default {
    name: "NotFound",
    methods: {
        home() {
            //setRoutes()
            this.$router.push("/")
        }
    }
}
</script>

<style>
.bgImg {
    background: url("../assets/404.png") no-repeat;
    background-size: 100% 100vh;
}
</style>
